import {
  colors,
  getForegroundColorForColor,
} from '@shoflo-rundown/cuesheet-data-helper';
import { getUserColor } from '@shoflo-rundown/polymer.legacy';

export default {
  getGlobalHighlightStyle(item) {
    let color = item.getIn(['settings', 'highlightClass']);

    if (!color || color === 'highlight-none') return null;
    color = color.replace('highlight-', '');

    return {
      backgroundColor: colors[color],
      color: getForegroundColorForColor(color),
    };
  },

  getPersonalHighlightStyle(item, userId) {
    let color = item.getIn(['userSettings', userId, 'highlightClass']);

    if (!color || color === 'highlight-none') return null;
    color = color.replace('highlight-', '');

    return {
      borderTopColor: colors[color],
    };
  },

  getPersonalHighlightClass(item, userId) {
    let color = item.getIn(['userSettings', userId, 'highlightClass']);

    if (!color || color === 'highlight-none') return null;

    return 'cs-cell-personal-highlight';
  },

  getCollabBackgroundStyle(collabItem) {
    if (!collabItem || collabItem.get('type') !== 'editing') return {};

    const user = collabItem.get('user');
    const color = getUserColor(user.get('_id'));
    const { r, g, b } = color;

    const collabStyle = {};

    collabStyle.backgroundColor = `rgba(${r}, ${g}, ${b}, .4)`;

    return collabStyle;
  },

  getCollabBorderStyle(collabItem) {
    if (!collabItem) return {};

    const user = collabItem.get('user');
    const color = getUserColor(user.get('_id'));
    const { r, g, b } = color;

    const collabStyle = { border: `2px solid rgb(${r}, ${g}, ${b})` };

    return collabStyle;
  },
};
